import React, { useMemo } from 'react'

import IndexItem from '../../../../../components/pdf/IndexItem'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import {
  getReplyValue,
  findReplyByQuestionName,
  filterRepliesByQuestionName,
  findReplyByReference,
  filterRepliesByParentReference,
  getJobDescription,
  remapReplies,
  remapReplyChildren
} from '../../_helpers/pdfHelpers'

const IndexSection = ({ serviceOrder }) => {
  const remap = useMemo(() => remapReplyChildren(serviceOrder.replies), [serviceOrder.replies])
  const riskMap = useMemo(() => {
    const result = {}
    const replies = filterRepliesByQuestionName(
      serviceOrder.replies,
      'Há riscos físicos, químicos, biológicos, acidentes ou ergonômicos na agencia? VER LISTA ABAIXO'
    )
    replies.forEach(reply => {
      if (reply.value) {
        const funcao = findReplyByReference(serviceOrder.replies, reply.question.parentReference).question.name
        const nomeFuncao = getJobDescription(funcao).funcao
        const outrasRespostasDoMesmoPai = filterRepliesByParentReference(
          serviceOrder.replies,
          reply.question.parentReference
        )
        const totalEmployees = getReplyValue(
          findReplyByQuestionName(outrasRespostasDoMesmoPai, 'Quantos funcionários possui nesse cargo?')
        )
        reply.value.forEach(value => {
          const { name } = value
          const cleanName = name
            .replace('ACIDENTES - ', '')
            .toLowerCase()
            .replace(/^\w/, c => c.toUpperCase())
          if (!result[cleanName]) {
            result[cleanName] = []
          }

          result[cleanName].push({ totalEmployees, funcao: nomeFuncao, nomeRisco: cleanName })
        })
      }
    })

    return result
  }, [serviceOrder.replies])

  const dangersByFunction = useMemo(() => {
    const { atendimento, comercial } = remapReplies(serviceOrder.replies, remap)

    const replies = atendimento.concat(comercial).map(reply => {
      const value = getReplyValue(
        findReplyByQuestionName(
          reply.childrenReplies,
          'Há riscos físicos, químicos, biológicos, acidentes ou ergonômicos na agencia? VER LISTA ABAIXO'
        )
      )
      const totalEmpolyees = getReplyValue(
        findReplyByQuestionName(reply.childrenReplies, 'Quantos funcionários possui nesse cargo?')
      )
      return {
        ...reply,
        totalEmpolyees,
        riscos: value
      }
    })

    return replies.filter(n => n)
  }, [serviceOrder.replies, remap])

  const bigTablePages = useMemo(() => {
    const riksTotal = Object.keys(riskMap).length

    if (riksTotal <= 2) {
      return 1
    } else {
      return 2
    }
  }, [riskMap])

  const data = useMemo(() => {
    let totalRiscos = 0
    Object.keys(riskMap).forEach(risco => {
      totalRiscos += riskMap[risco].length
    })
    return {
      totalRiscos,
      riscosPorFuncao: dangersByFunction.length
    }
  }, [riskMap, dangersByFunction])

  const dinamicPages = useMemo(() => {
    let pages = bigTablePages
    if (data.totalRiscos <= 1) {
      pages += 1
    }
    if (data.totalRiscos > 1) {
      pages += 2
    }
    if (data.riscosPorFuncao <= 3) {
      pages += 1
    } else {
      pages += 2
    }

    return pages
  }, [data, bigTablePages])

  return (
    <View pageBreakAfter>
      <Separator weight={15} />
      <Text bold size="small" align="center">
        ÍNDICE
      </Text>
      <Separator weight={8} />
      <IndexItem label="1. INFORMAÇÕES INICIAIS" name="1" page={4} />
      <IndexItem label="1.1 IDENTIFICAÇÃO DA EMPRESA" name="1" page={4} />
      <IndexItem label="1.2. IDENTIFICAÇÃO DOS RESPONSÁVEIS PELO PROGRAMA E VISTORIA" name="1" page={4} />
      <IndexItem label="1.3. IDENTIFICAÇÃO DA UNIDADE" name="1" page={5} />
      <IndexItem label="2. INTRODUÇÃO" name="2" page={6} />
      <IndexItem label="3. ESTRUTURA" name="3" page={11} />
      <IndexItem label="4. INVENTÁRIO DE RISCOS" name="4" page={16} />
      <IndexItem label="5. CRONOGRAMA DO INVENTÁRIO DE RISCOS E PLANO DE AÇÃO" name="5" page={18 + dinamicPages} />
      <IndexItem label="6. DISCUSSÃO DO PLANO DE AÇÃO E CONSIDERAÇÕES FINAIS" name="6" page={18 + dinamicPages} />
      <IndexItem label="7. ASSINATURA" name="7" page={18 + dinamicPages} />
      <IndexItem label="8. ANEXOS" name="8" page={18 + dinamicPages + 1} />
      <IndexItem label="ANEXO I" name="8.1" page={18 + dinamicPages + 1} />
      <Separator weight={8} />
    </View>
  )
}

export default IndexSection
